import styled, { css } from "styled-components";
import { ProductNameVariant } from "../components/ProductName";

interface StyleProps {
  $variant: ProductNameVariant;
}

const highlightVariant = css`
  margin: 0;
  margin-bottom: 15px;

  @media (max-width: 1225px) {
    margin-bottom: 5px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
const modalVariant = css`
  color: black;
  font-size: 1rem;
`;

function getVariant(variant: ProductNameVariant) {
  if (variant === "highlight") return highlightVariant;
  if (variant === "modal") return modalVariant;
  return "";
}

export const SpanProductName = styled.span<StyleProps>`
  margin: 0 0 10px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  --line-height: 1.4;
  height: calc(var(--line-height) * 2em);
  line-height: var(--line-height);
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;

  ${({ $variant }) => getVariant($variant)}
`;
